import { z } from 'zod';
import { DiscountType, InventoryItemStatus } from '@trnsact/trnsact-shared-types';

export const equipmentDeliverySchema = z.object({
  state: z.string({ invalid_type_error: 'Required' }).min(1, 'State is required'),
  city: z
    .string({ invalid_type_error: 'Required' })
    .trim()
    .min(1, 'City is required')
    .max(100, 'City must be 100 characters or fewer'),
  streetAddress: z
    .string({ invalid_type_error: 'Required' })
    .trim()
    .min(1, 'Address is required')
    .max(200, 'Address must be 200 characters or fewer'),
  country: z
    .string({ invalid_type_error: 'Required' })
    .trim()
    .min(1, 'Country is required')
    .max(100, 'Country must be 100 characters or fewer'),
  postalCode: z
    .string({ invalid_type_error: 'Required' })
    .trim()
    .min(1, 'Postal code is required')
    .max(20, 'Postal code must be 20 characters or fewer'),
});

export const commonInfoSchema = z.object({
  vin: z.string(),
  year: z.string(),
  make: z.string(),
  model: z.string(),
  stockId: z.string(),
  saleCost: z.number(),
  condition: z.string(),
  retailPrice: z.number(),
  description: z.string(),
  wholeSaleCost: z.number(),
  discountValue: z.number(),
  class: z.number().nullable(),
  quantity: z.number().nullable(),
  mileage: z.number().nullable(),
  discountType: z.nativeEnum(DiscountType),
  inventoryItem: z.object({
    status: z.nativeEnum(InventoryItemStatus),
    inventoryId: z.string().nullable(),
  }),
});

export const equipmentAttachmentSchema = z.object({
  type: z.string(),
  model: z.string(),
  unitCost: z.number(),
  retailPrice: z.number(),
  category: z.string(),
  manufacturer: z.string(),
  quantityPerAsset: z.number(),
  discountValue: z.number(),
  discountType: z.nativeEnum(DiscountType),
});

export const equipmentFormSchema = z.object({
  commonInfo: commonInfoSchema,
  attachments: z.array(equipmentAttachmentSchema),
  calcPricing: z.object({
    retail: z.object({
      total: z.number(),
      attachments: z.number(),
    }),
    customer: z.object({
      total: z.number(),
      equipment: z.number(),
      attachments: z.number(),
    }),
    wholesale: z.object({
      total: z.number(),
      attachments: z.number(),
    }),
  }),
});
